


















import { Component, Vue, Prop } from 'vue-property-decorator'
import {getUploadToken, qiniuUpload1} from '@/apis/common'
import {getFormatDate} from '@/utils/common'
import {qiniuUploadUrl, qiniuDownloadTmp, globalType} from '@/utils/constant'
import { Toast } from 'vant'
@Component({
	name: 'uploader'
})
export default class Uplodaer extends Vue {
	@Prop({default: () => ''}) public keyFun!: any
	@Prop({default: false}) public disabled!: boolean
	@Prop({default: 50}) public fileSize!: number
	@Prop({default: () => ([])}) public uploadList!: any
	public fileList: any[] = []
	public uploadData = {token: '', key: '', name: ''}
	private loading: boolean = false
	private uploadUrl = qiniuUploadUrl
	private headers: any = {
    'Content-type': 'multipart/form-data'
	}
	private a = []
	public get fileMaxSize () {
		return (this.fileSize) * 1024 * 1024
	}
	// 文件上传完毕回调
	public async afterRead (file) {

		const formData = new FormData()
		formData.append('file', file.file)
		formData.append('token', this.uploadData.token)
		formData.append('key', this.uploadData.key)
		let res = await qiniuUpload1(formData, this.uploadUrl)
		if (res && res.key) {
			let uploadFile = {url: qiniuDownloadTmp + res.key, fileName: this.uploadData.name, createTime: getFormatDate(new Date())}
			this.$emit('uploadSuccess', uploadFile)
		}
	}
	public async beforeUpload (file) {
		if (this.disabled) {
			return false
		}
		if (file.size > (this.fileSize) * 1024 * 1024) {
			Toast.fail({
				duration: 2000,
				message: '附件大于' + (this.fileSize) + 'mb'
			})
			return false
		}
		let type = file.name.split('.').pop()
		if (globalType === 'public') {
			let res = await getUploadToken(0)
			if (res.success) {
				this.uploadData.token = res.data
				this.uploadData.key = this.keyFun(type)
				this.uploadData.name = file.name
				return false
			}
		} else {
			this.uploadData.key = this.keyFun(type)
			this.uploadData.name = file.name
			return false
		}
	}
	// 文件上传成功
  public handleSuccess (response, file, fileList) {
		let fileUrl = response.key
		let trueName = file.name
		let uploadFile = {url: qiniuDownloadTmp + fileUrl, fileName: file.name, createTime: getFormatDate(new Date())}
		this.fileList.push(uploadFile)
		this.$emit('uploadSuccess', uploadFile)
		// this.attachs.push(uploadFile)
	}
}
